/** @format */

import {ComponentBag, IsoDate} from '../types';

export const aggregateBag = (
  bagByDay: Partial<Record<IsoDate, ComponentBag>>,
  days: IsoDate[],
): ComponentBag => {
  const result: ComponentBag = {};

  // Инвариант: компоненты производной метрики имеют фиксированную форму (все дни несут один набор
  // ключей), поэтому динамический zero-seed по всем дням эквивалентен легаси-сидингу фиксированного
  // нулевого ComplexValue. Если бы хоть один ключ отсутствовал во ВСЕХ днях, предикат получил бы
  // undefined вместо 0 — на реальных данных это не достижимо.
  // Сидим нулями все ключи, встречающиеся в любом дне (как фиксированный нулевой ComplexValue).
  Object.values(bagByDay).forEach(bag => {
    if (!bag) return;
    Object.keys(bag).forEach(key => {
      if (!(key in result)) {
        result[key] = 0;
      }
    });
  });

  days.forEach(day => {
    const bag = bagByDay[day];
    if (!bag) {
      return;
    }
    Object.keys(bag).forEach(key => {
      result[key] += bag[key];
    });
  });

  return result;
};
